import React from 'react';
import PropTypes from 'prop-types';
import { get, pick } from 'lodash';
import classnames from 'classnames';

import { withSearchHandler } from 'decorators';
import { buildStartHereLink } from 'lib/search';

import { Container } from 'components/core/Page';
import { HH, H2 } from 'components/core/Headline';
import { Paragraph } from 'components/core/Typography';
import { Link } from 'components/core/Link';
import { SearchBox } from 'components/search/SearchBox';
import { StickySearchBar } from 'components/landing/StickySearchBar';
import { Search } from 'components/svg';

import comparePrices from 'assets/images/icons/search-hero/compare-prices.svg';
import exclusiveDeals from 'assets/images/icons/search-hero/exclusive-deals.svg';
import freeReservation from 'assets/images/icons/search-hero/free-reservation.svg';
import noCreditCard from 'assets/images/icons/search-hero/no-credit-card.svg';
import { Image } from 'components/core/Image';

import './CLPHero.scss';

const withComputedProps = (Component) => (props) => {
	const searchLinkParams = {
		...pick(props.searchLocation, ['city', 'state']),
		informedSearch: true,
		...get(props, 'queryParams'),
	};
	return (
		<Component
			{...props}
			additionalSearchParams={{ informedSearch: true }}
			startHereLink={buildStartHereLink({ ...searchLinkParams })}
		/>
	);
};

export const enhance = (Component) =>
	withComputedProps(withSearchHandler(Component));

export function CLPHero({
	searchLocation, handleSearch, startHereLink, headline, subtitle, className
}) {
	const { city } = searchLocation;
	return (
		<>
			<div className={classnames('clp-hero', className)}>
				<Container gutters="large">
					<div className="section-content">
						<H2 strong className="subheading">
							{subtitle}
						</H2>
						<HH rounded>
							{headline}

						</HH>
						<ul className="section-points">
							<li>
								<Image src={comparePrices} className="icon" alt="" />
								Compare Storage Prices
							</li>
							<li>
								<Image src={freeReservation} className="icon" alt="" />
								Free Reservation
							</li>
							<li>
								<Image src={exclusiveDeals} className="icon" alt="" />
								Find Exclusive Deals
							</li>
							<li>
								<Image src={noCreditCard} className="icon" alt="" />
								No Credit Card Required
							</li>
						</ul>
					</div>
				</Container>
			</div>

			<Container>
				<div className={classnames('hero-search-box', className)}>
					<Paragraph className="search-box-label" color="black">
						<strong>Enter Your ZIP Code&nbsp;</strong>
						to Explore More Relevant Results
					</Paragraph>
					<SearchBox
						id="clp-sticky-search"
						inputLabel="Enter ZIP code"
						handleSearch={handleSearch}
						hideOnScroll
						buttonIcon={true}
						buttonText="Find storage"
					/>
				</div>
				<Paragraph className="zip-message" color="gray" last>
					Don’t know the zip code you want in {city}?
					{' '}
					<Link
						href={startHereLink}
						rel="nofollow"
					>
						Start here
					</Link>
				</Paragraph>
			</Container>
			<StickySearchBar triggerId="clp-sticky-search" handleSearch={handleSearch} />
		</>
	);
}

CLPHero.propTypes = {
	searchLocation: PropTypes.object,
	handleSearch: PropTypes.func,
	startHereLink: PropTypes.string.isRequired,
	headline: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	className: PropTypes.string
};

export default enhance(CLPHero);
